import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody, FlexColumn, TextBody } from "@opensea/ui-kit";
import { uniqBy } from "es-toolkit/compat";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen";
import { useNavigation } from "../../../../../providers/NavigationProvider";
import { ListingFlowDone_itemFragment } from "./ListingFlowDone.fragment";
export const ListingFlowDone = t0 => {
  const $ = _c(21);
  const {
    title,
    body,
    items: itemsKey,
    withLink,
    withError
  } = t0;
  const t = useTranslations("wallet.ListingFlowDone");
  const {
    renderLink: Link,
    onClick
  } = useNavigation();
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  if ($[0] !== Link || $[1] !== body || $[2] !== itemsKey || $[3] !== onClick || $[4] !== t || $[5] !== withLink) {
    const items = itemsKey.map(_temp);
    const collections = uniqBy(items.map(_temp2), "id");
    const collection = collections.length === 1 ? collections[0] : undefined;
    const item_1 = items[0];
    const itemUrl = `/item/${item_1.chain.identifier.toLowerCase()}/${item_1.contractAddress}/${item_1.tokenId}`;
    const renderBottom = () => {
      if (!withLink) {
        return null;
      }
      if (items.length === 1) {
        return <FlexColumn className="items-center gap-4"><TextBody>{t("youListed")}{" "}<Link href={itemUrl} onClick={onClick}>{item_1.name}</Link><CollectionCopy collection={collection} />!</TextBody><Button href={itemUrl} size="lg" variant="secondary">{t("viewItemPage")}</Button></FlexColumn>;
      }
      return <TextBody>{t("youListedMultiple", {
          count: items.length
        })}<CollectionCopy collection={collection} />!</TextBody>;
    };
    T1 = BottomSheetBody;
    T0 = TransactionFullScreen;
    t1 = body;
    t2 = renderBottom();
    t3 = items.map(_temp3);
    $[0] = Link;
    $[1] = body;
    $[2] = itemsKey;
    $[3] = onClick;
    $[4] = t;
    $[5] = withLink;
    $[6] = T0;
    $[7] = T1;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    T0 = $[6];
    T1 = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  let t4;
  if ($[11] !== T0 || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== title || $[16] !== withError) {
    t4 = <T0 body={t1} bottom={t2} images={t3} monochrome={withError} title={title} />;
    $[11] = T0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = title;
    $[16] = withError;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== T1 || $[19] !== t4) {
    t5 = <T1>{t4}</T1>;
    $[18] = T1;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
function CollectionCopy(t0) {
  const $ = _c(13);
  const {
    collection
  } = t0;
  const t = useTranslations("wallet.ListingFlowDone");
  const {
    renderLink: Link,
    onClick
  } = useNavigation();
  if (!collection) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("fromThe");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/collection/${collection.slug}`;
  let t3;
  if ($[2] !== Link || $[3] !== collection.name || $[4] !== onClick || $[5] !== t2) {
    t3 = <Link href={t2} onClick={onClick}>{collection.name}</Link>;
    $[2] = Link;
    $[3] = collection.name;
    $[4] = onClick;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("collection");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t5 = <>{" "}{t1}{" "}{t3}{" "}{t4}</>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(item) {
  return readFragment(ListingFlowDone_itemFragment, item);
}
function _temp2(item_0) {
  return item_0.collection;
}
function _temp3(item_2) {
  return item_2.imageUrl;
}